import DebugFeedSuccess from './DebugFeedSuccess'
export default DebugFeedSuccess
